import PropTypes from 'prop-types'
import React from 'react'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

const popover = (props) => (
  <Popover id='sch-net-programs-app-popover'>
    {props.title && (<Popover.Header as='h3'>{props.title}</Popover.Header>)}
    <Popover.Body>
      {props.body}
    </Popover.Body>
  </Popover>
)

const InfoPopup = (props) => (
  <OverlayTrigger trigger='click'
                  overlay={popover(props)}
                  transition={false}
                  container={props.containerRef.current}
                  containerPadding={20}
                  placement='auto'
                  rootClose={true}
  >
    <small style={{ cursor: 'pointer' }}>
      &nbsp;
      <span className='badge badge-dark'>?</span>
    </small>
  </OverlayTrigger>
)

InfoPopup.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string.isRequired,
  containerRef: PropTypes.object
}

export default InfoPopup
